<div class="pt-6">
  <aiwyn-logo [height]="60" [extraClasses]="'client-logo'" (click)="goBack()"></aiwyn-logo>
</div>

<div class="authentication-body">
  @if (isSubmissionProcessing$ | async) {
    <h2>Signing in...</h2>
  } @else if (passwordlessEmail().status === LoadableStatus.LOADING) {
    <mat-spinner></mat-spinner>
  } @else {
    <h2>Finish signing in</h2>

    <p class="body-400 text-center">
      Please enter your email and click the continue button to complete the sign in process.
    </p>

    <form name="emailSignInForm" [formGroup]="emailSignInForm" novalidate class="w-100">
      <div class="w-100">
        <label class="body-400 color-gray-300 ta--left">Email address</label>

        <div class="input-div position-relative mt-2">
          <input
            type="email"
            name="email"
            [formControl]="emailControl"
            placeholder="Email address"
            class="form-input pe-8"
            [ngClass]="{ 'form-input--invalid': (emailControl.errors && canShowValidationErrors(emailControl)) }"
            data-cy="username"
          >

          <div class="form-control__post-icon">
            <svg
              viewBox="0 0 24 24"
              width="16"
              height="16"
              stroke="currentColor"
              stroke-width="2"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
              <polyline points="22,6 12,13 2,6"></polyline>
            </svg>
          </div>
        </div>

        @if (emailControl.errors && canShowValidationErrors(emailControl)) {
          @if (emailControl.errors.required) {
            <mat-error class="mt-2">Email is required</mat-error>
          }
          @if (emailControl.errors.email && !emailControl.errors.required) {
            <mat-error class="mt-2">Please enter a valid email</mat-error>
          }
        }
      </div>

      <button andButton color="primary" size="large" [isLoading]="isSubmissionProcessing$ | async" class="w-100 mt-6" (click)="submit()">
        Continue
      </button>
    </form>
  }
</div>

<app-full-client-portal-footer class="px-6 pb-6"></app-full-client-portal-footer>
